import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/store";
// import FileContextProvider from "./context/ContextProvider";
// import './fonts/ChalkboardSE-Regular.ttf';
import PWAPrompt from 'react-ios-pwa-prompt';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
			<Provider store={store}>
				<App />
			</Provider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
